import {  SET_OPEN_MODAL_SUBVENCOES } from "../actionTypes"

export const setOpenModalSubvencoes = (open = false) => {
    return {
        type: SET_OPEN_MODAL_SUBVENCOES,
        payload: open
    }
 }
